import { Banner } from '@shopify/polaris';
import useOpenHelpCenter from 'hooks/help-center/useOpenHelpCenter';
import { useTranslation } from 'react-i18next';

const CarrierServiceWarning = () => {
    const { t } = useTranslation();

    const openHelpCenter = useOpenHelpCenter(8286656, 'article', 'carrier_service_warning');

    return (
        <Banner
            title={t('INTEGRATION_MODE.WARNING_BANNER.ACTION_REQUIRED')}
            tone={'warning'}
            action={{
                content: t('INTEGRATION_MODE.WARNING_BANNER.MORE_DETAILS'),
                onAction: openHelpCenter,
            }}
            onDismiss={() => {}}
        >
            {t('INTEGRATION_MODE.WARNING_BANNER.DESC')}
        </Banner>
    );
};

export default CarrierServiceWarning;
